import config from './config';
import axios from 'axios';

const API_KEY = '49b04966-3a4c-11e7-9fb0-1b2783622b34';

function dummyAuth () {
  return new Promise((resolve, reject) => {
    return resolve({});
  });
}

export default {

  post: function (person) {
    return new Promise((resolve, reject) => {
      // Vue.prototype.$auth.getAuthorizationHeader()
      dummyAuth()
        .then( (authHeader) => {
          authHeader.apikey = API_KEY;
          var url = config.getURI(`/api/people`, `project=${config.project}`);

          // convert the json to string
          // TODO: Is this actually necessary? Doesnt AXIOS handle this? I introduced it through since there were issues before.
          // Surveys does not do this... Is it due to the source of the argument being passed in? Person is Vuejs object while Survey Answers are constructed separately
          // COPY was needed when trying to use arg in as reference to VueJS object directly. var personToCreate = JSON.parse(JSON.stringify(person)); // deep copy
          if (person.extras && typeof person.extras !== 'string') {
            person.extras = JSON.stringify(person.extras);
          }

          axios({
            method: 'POST',
            url: url,
            data: person,
            headers: authHeader
          })
            .then(response => {
              // console.log('created Person ', response.guid);
              resolve(response.data);
            })
            .catch( (error) => {
              reject(error);
            });
        })
        .catch( error => {
          reject(error);
        });
    });
  },
};



// WEBPACK FOOTER //
// ./src/lib/people.js